interface Props {
  className?: string;
}

export const Facebook = ({ className }: Props) => (
  <div className={className}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 28 28"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M27.3333 13.9998C27.3333 6.63984 21.36 0.666504 14 0.666504C6.64 0.666504 0.666672 6.63984 0.666672 13.9998C0.666672 20.4532 5.25334 25.8265 11.3333 27.0665V17.9998H8.66667V13.9998H11.3333V10.6665C11.3333 8.09317 13.4267 5.99984 16 5.99984H19.3333V9.99984H16.6667C15.9333 9.99984 15.3333 10.5998 15.3333 11.3332V13.9998H19.3333V17.9998H15.3333V27.2665C22.0667 26.5998 27.3333 20.9198 27.3333 13.9998Z" />
    </svg>
  </div>
);
